export enum ErrorType {
    Forbidden = 0,
    Other
}

export interface ApiError {
    errType: ErrorType
    data?: any
}

export function isApiError<T>(result: T | ApiError): result is ApiError {
    return result && (result as ApiError).errType !== undefined;
}